import React from 'react'

import { Box, ExternalLink, RadioButtons } from '@labrav/react-components'
import { Typography } from '@mui/material'
import { useStyles } from './Renewal.styles'
import { KeyValue } from '../../../modules/privateOffer/privateOfferCreation/types'
import { microsoftRenewalResourceLink, renewalTypes } from './utils'

export type OfferedTypes = 'offer' | 'resale authorization'
export type RenewalProps = {
  existingContractRenewal: boolean
  handleDetailsChange: (data: KeyValue) => void
}

export const RenewalMicrosoft = React.memo(
  ({ existingContractRenewal, handleDetailsChange }: RenewalProps) => {
    const { classes } = useStyles()
    const existingContractRenewalValue = existingContractRenewal
      ? 'RENEWAL'
      : 'NEW'
    const handleUpdate =
      (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        handleDetailsChange({ key, value: event.target.value === 'RENEWAL' })
      }
    const renewalResourceLink = microsoftRenewalResourceLink

    return (
      <Box
        heading={'Customer renewals'}
        subHeading={'Agency fee discount for renewals'}
      >
        <div>
          {
            <>
              <div className={classes.subHeadingContainerMicrosoft}>
                <Typography
                  className={classes.labelText}
                  data-testid="renewal-type-subheading"
                >
                  <p>
                    By selecting as renewal, you acknowledge and affirm that
                    this private offer is a renewal of:
                  </p>
                  <p>(i) a current private offer or</p>
                  <p>
                    (ii) an existing paid agreement still in effect outside of
                    the Commercial Marketplace.
                  </p>
                  <p>
                    Microsoft may evaluate your private offer and you must
                    provide information regarding the renewal as requested by
                    Microsoft.
                  </p>
                  <p>
                    Microsoft reserves the right to chargeback or offset any
                    difference in payout amounts you may have received because
                    of the renewal fee discount.
                  </p>
                  {
                    <ExternalLink href={renewalResourceLink}>
                      {'Learn more'}
                    </ExternalLink>
                  }
                </Typography>
              </div>
              <RadioButtons
                checkedValue={{
                  key: existingContractRenewalValue,
                  value: existingContractRenewalValue,
                }}
                handleChange={handleUpdate('existingContractRenewal')}
                radioButtonMappings={renewalTypes}
              />
            </>
          }
        </div>
      </Box>
    )
  }
)
